namespace Nobox.NoBoxCRM {
    export interface FormresultsRow {
        Id?: number;
        IsPaid?: number;
        St?: number;
        TagIds?: string;
        DateIn?: string;
        FormId?: number;
        Form?: string;
        FrmFollowUp?: string;
        FrmIsSendWa?: number;
        FrmIsSendMail?: number;
        FrmDataWa?: string;
        FrmDataMail?: string;
        FollowUp?: string;
        SenderNm?: string;
        Phone?: string;
        Data?: string;
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
        Products?: CRM.ProductsRow[];
    }

    export namespace FormresultsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SenderNm';
        export const localTextPrefix = 'NoBoxCRM.Formresults';
        export const lookupKey = 'NoBoxCRM.Formresults';

        export function getLookup(): Q.Lookup<FormresultsRow> {
            return Q.getLookup<FormresultsRow>('NoBoxCRM.Formresults');
        }
        export const deletePermission = 'ProductTags:Delete';
        export const insertPermission = 'ProductTags:Modify';
        export const readPermission = 'ProductTags:View';
        export const updatePermission = 'ProductTags:Modify';

        export declare const enum Fields {
            Id = "Id",
            IsPaid = "IsPaid",
            St = "St",
            TagIds = "TagIds",
            DateIn = "DateIn",
            FormId = "FormId",
            Form = "Form",
            FrmFollowUp = "FrmFollowUp",
            FrmIsSendWa = "FrmIsSendWa",
            FrmIsSendMail = "FrmIsSendMail",
            FrmDataWa = "FrmDataWa",
            FrmDataMail = "FrmDataMail",
            FollowUp = "FollowUp",
            SenderNm = "SenderNm",
            Phone = "Phone",
            Data = "Data",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy",
            Products = "Products"
        }
    }
}
